export default __webpack_public_path__ + "static/media/active-right.a891ac1d.svg";